import {FC, useMemo} from 'react'
import {RootState} from 'setup'
import {
  selectEditOrder,
  selectEditOrderItems,
  selectIsCompliantFetch,
  selectIsProductsEditMode,
  selectIsValidatingDiscount,
  selectViewOrder,
  updateEditOrderWithItems,
} from 'app/features/orders/redux/order/orderEditSlice'
import {Order} from 'app/features/orders/models/EditOrderState'
import SummaryFooter from 'app/features/orders/componentsv1/shared/SummaryFooter'
import {EditPaymentSummary} from 'app/features/orders/componentsv1/edit'
import {useDispatch, useSelector} from 'react-redux'
import PreviousOrderSummary from './PreviousOrderSummary'
import ShippingMethod from './ShippingMethod'
import ShippingComplianceTax from './ShippingComplianceTax'
import Discounts from '../discount/Discounts'
import {ViewOrder, viewOrder} from 'app/features/orders/models/OrderState'
import {SummaryItem} from 'app/features/orders/componentsv1/shared'

type Props = {}

const Payment: FC<Props> = () => {
  const dispatch = useDispatch()
  const order = useSelector<RootState, Order>(selectEditOrder)
  const viewOrder = useSelector<RootState, ViewOrder>(selectViewOrder)
  const orderItems = useSelector<RootState, any[]>(selectEditOrderItems)
  const isValidating = useSelector<RootState, boolean>(selectIsValidatingDiscount)
  const isFetching = useSelector<RootState, boolean>(selectIsCompliantFetch)
  const isProductMode = useSelector<RootState, boolean>(selectIsProductsEditMode)

  const totalTitle = useMemo(() => {
    if (parseFloat(order.totalPrice) !== parseFloat(viewOrder.totalPrice)) {
      return 'New Total Price'
    }
    return 'Total Price'
  }, [order.totalPrice, viewOrder.totalPrice])

  const handleSave = async () => {
    await dispatch(updateEditOrderWithItems())
  }

  return (
    <EditPaymentSummary
      {...order}
      items={orderItems}
      isBetween={isProductMode}
      title={
        <>
          Summary{' '}
          {isValidating && (
            <span className='indicator-progress d-block'>
              <span className='spinner-border spinner-border spinner-border-sm align-middle ms-2 text-info'></span>
            </span>
          )}
        </>
      }
      footer={
        <>
          <SummaryFooter
            {...order}
            hideDiscounts
            totalTitle={totalTitle}
            hidePaymentMethod
            isBetween={isProductMode}
          >
            <PreviousOrderSummary />
          </SummaryFooter>
        </>
      }
    >
      <ShippingMethod onUpdateOrder={handleSave} disabled={isValidating || isFetching} />
      <Discounts />
      <ShippingComplianceTax disabled={isValidating || isFetching} />
      <SummaryItem
        title={
          <div className='d-flex align-items-center gap-20'>
            <div className='ms-9'></div>
            <span className='text-dark'>Tip Amount</span>
          </div>
        }
        value={viewOrder.tipAmount}
      ></SummaryItem>
    </EditPaymentSummary>
  )
}

export default Payment
